import { FC } from 'react';
import { Box } from '@mui/material';

import { TextInput, PhoneInput } from '@carcareers/components';

export interface UserInputProps {
  disabled?: boolean;
  disableEmail?: boolean;
}

export const UserInput: FC<UserInputProps> = ({ disabled = false, disableEmail = false }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <TextInput required label="First Name" name="user.firstName" autoComplete="given-name" disabled={disabled} />
      <TextInput required label="Last Name" name="user.lastName" autoComplete="family-name" disabled={disabled} />
      <TextInput required label="Email" name="user.email" autoComplete="email" disabled={disabled || disableEmail} />
      <PhoneInput required label="Phone Number" name="user.phone" autoComplete="tel" disabled={disabled} />
    </Box>
  );
};
